import { SocialLoginState } from '../types';
import { reduxKey } from '../constants';

function getSocialLoginState(state): SocialLoginState {
  return state[reduxKey] || {};
}

export function isFacebookSDKInitialized(state) {
  return getSocialLoginState(state).isFacebookSDKInitialized;
}

export function getErrorCode(state) {
  return getSocialLoginState(state).error;
}
